import type { LoggedOutHomePageContent } from 'bundles/front-page/__generated__/baseContentfulTypes';
import type { LoggedOutHomePageContentFieldsFragment } from 'bundles/front-page/__generated__/contentfulTypes';

export const getCollectionContents = <T extends {}>(
  pageContent: LoggedOutHomePageContentFieldsFragment,
  collectionName: keyof LoggedOutHomePageContent
): T[] | null => {
  // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  const collection = pageContent[collectionName];

  if (!collection || !collection.items) {
    return null;
  }

  return collection.items.filter((item: $TSFixMe): item is T => item !== null);
};
